define('routers/causes',["require", "subroute"], function (require, subroute) {
    "use strict";

    return Backbone.SubRoute.extend({
        initialize: function (options) {
            options = options || {};
        },
        routes: {
            /* matches http://payforward.com/causes*/
            "": "showCauses",
            "createCause": "showCreateCause",
            "discover": "showDiscoverCauses",
            //  "Causes": "showConsumerAccounts",
            //"Causes": "showConsumerAccountsAlloc",
            //"AccountInfo": "showAccountInfo",
            ":ID/edit": "showMicrositeEdit",
            ":AGID/balances": "showCauseBalances",
            ":AGID/updates": "showCauseUpdates",
            ":AGID/info": "showCauseInfo",
            ":AGID/participants": "showParticipants",
            // ":AGID/calendar": "showCauseCalendar",
            ":AGID/updates/:PGID(/:SFI)": "showPostDetail",
            ":ID(/:A)": "showMicrosite",            
            //"ResetPassword/:GUID": "showResetPasswordView",
            //"Accounts/:AID/Participants/:PN": "showParticipants",
            //"Accounts/Participant": "showParticipant",
            //"Causes/:AGID": "showParticipant",
            //"Cause/:ID/Participants(/:SS)/:PN": "showParticipants",
            //"Cause/:ID/Conversations(/:P)": "showCauseConversations",
            //"Cause/:ID/News(/:P)": "showCauseNews",
            ":ID/Settings": "showCauseSettings"
            
        },
        before: function (route, params) {
            if (route) {
                var zaccess = checkAccess(route);
                if (!zaccess)
                    return false;
                pf.globalEvents.trigger("Navigation:Changed", "causes");
            }
        },
        after: function (route, params) {
            if (route) {}
        },
        showCauses: function (subNav) {

        },
        showDiscoverCauses: function () {
            if (pf.session.get("auth")) {
                this.showCauses('discover');
            } else {
                //require(["views/causes/mycauses/noauthdiscovercauses"], function (DiscoverCausesView) {
                //    pf.show(new DiscoverCausesView({ elementName: "#mainRegion" }));
                //});
            }
        },
        showCreateCause: function () {
            this.showCauses("createCause");
        },
        showPostDetail: function (AGID, PGID, SFI) {            
            var options = { ID: AGID, PostGUID: PGID, SFI: SFI, subNav: "postdetails", elementName: "#mainRegion" };            

            
        },
        showMicrosite: function (ID, A, subNav, createNew) {
            var isAdmin = false;
            if (A == 'Admin') {
                isAdmin = true;
            }
            if (createNew != false)
                createNew = true;          


        },
        showMicrositeEdit: function (ID, subNav) {            
            //this.showMicrosite(ID, 'Admin', 'edit', false);

            
        },
        showCauseSettings: function (ID) {
            store.setStoreItem(enums.modelsEnum.CurrentContext, { Data: enums.HelpContext.CauseSettings });

            //var SettingsView = require("views/shared/settings/settings");
            //pf.show(new SettingsView({ ID: ID, SF: pf.enums.settingFor.Account, elementName: "#mainRegion" }));

            
        },
        showParticipants: function (AGID) {            
            this.showMicrosite(AGID, null, 'participants',false);
        },
        // showCauseCalendar: function (AGID) {            
        //     this.showMicrosite(AGID, null, 'calendar',false);
        // },
        showCauseUpdates: function (AGID) {
            this.showMicrosite(AGID, null, 'updates', false);
        },
        showCauseBalances: function (AGID) {          
            this.showMicrosite(AGID, null, 'balances', false);
        },
        showCauseInfo: function (AGID) {
            this.showMicrosite(AGID, '', 'info',false);
        },
        showParticipant: function () {
            //var participantView = require(["views/causes/causedetail/participants/participant"], function (participantView) {
            //    pf.show(new participantView({ elementName: "#mainRegion" }));
            //});

            

        },
    });
});

